
define('jsx!components/modal/share/share-direct-student',[
	"underscore",
	"jquery",
	"react",
	"shared/user"
], function(_, $, React, User) {
	return React.createClass({
		displayName: "ShareCode",
		getInitialState: function() {
			return {
				loading: true,
				sharedWith: {},
				canBeSharedWith: {},
				selectedUsers: []
			};
		},
		hide: function(e) {
			this.props.hideModal(e);
		},
		componentWillMount: function() {
			var self = this;
			this.pullCurrentShareState();
		},
		pullCurrentShareState: function() {
			var self = this;
			this.setState({
				loading: true
			});
			window.api.request("share", this.props.stores.buncee.getBuncee().guid, {entity_type: 'buncee'}).execute().done(function(response) {
				var canBeSharedWith = response.data.can_be_shared_with;
				var selectedUsers = [];
				response.data.shared_with.forEach(function(sharedEntity) {
					selectedUsers.push(sharedEntity.user_guid);
				});
				self.setState({
					sharedWith: response.data.shared_with,
					canBeSharedWith: response.data.can_be_shared_with,
					selectedUsers: selectedUsers,
					loading: false
				})
			});
		},
		save: function() {
			var recipients = [];
			var self = this;

			this.state.selectedUsers.forEach(function(guid) {
				recipients.push({
					user_guid:guid
				});
			})

			this.setState({
				loading: true
			});

			window.api.request("share").create({
				"entity_type": "buncee",
				"entity_guid": this.props.stores.buncee.getBuncee().guid,
				recipients: recipients
			}).done(function(response) {
				self.pullCurrentShareState();
				self.props.actions.toast(".buncee-modal-action", "Shared");
			});
		},
		handleUserCheckboxChange: function(e) {
			var checked = e.target.checked;
			var userGUID = e.target.getAttribute('id');
			if(checked) {
				this.setState({
					selectedUsers: this.state.selectedUsers.concat([userGUID])
				})
			} else {
				var selectedUsers = this.state.selectedUsers.slice(0);
				selectedUsers.splice(selectedUsers.indexOf(userGUID), 1);
				this.setState({
					selectedUsers: selectedUsers
				});
			}
		},
		userCheckbox: function(user) {
			var disabled = false;
			var isSelected = false;
			if(!user) {
				return;
			}  else if(this.state.selectedUsers.indexOf(user.guid) > -1) {
				isSelected = true;
			}

			return (
				React.createElement("div", {key: user.guid, className: "md-checkbox col-sm-6"}, 
					React.createElement("input", {id: user.guid, type: "checkbox", checked: isSelected, disabled: disabled, onChange: this.handleUserCheckboxChange}), 
					React.createElement("label", {htmlFor: user.guid}, user.name)
				)
			)
		},
		render: function() {
			var self = this;
			if(this.state.loading) {
				return (React.createElement("div", {className: "direct-options student"}, React.createElement("div", {className: "loader"}
				)));
			} else {
				var teachers = this.state.canBeSharedWith.user;
				teachers = _.sortBy(_.values(teachers), function(teacher) {
					return teacher.name
				});
				
				return (
					React.createElement("div", {className: "direct-options student"}, 
						React.createElement("div", {className: "loader", style: {display: "none"}}
						), 
						React.createElement("div", {className: "form-group"}, 
							React.createElement("label", {htmlFor: "teachersDropwdown", className: "col-sm-3 col-md-3 col-lg-3 control-label"}, "Share With"), 
							React.createElement("div", {className: "col-sm-9 col-md-9 col-lg-9"}, 
								React.createElement("div", {className: "user-list"}, 
									
										_.map(teachers, function(teacher) {
											return (self.userCheckbox(teacher));
										})
									
								)
							)
						), 
						React.createElement("div", {className: "buncee-modal-buttons col-sm-12"}, 
							React.createElement("button", {className: "modal-button", onClick: this.save, onTouchEnd: this.save}, "SHARE"), 
							React.createElement("button", {className: "modal-button button-red", onClick: this.hide, onTouchEnd: this.hide}, "CLOSE")
						)
					)
				);
			}
		}
	});
});
